// extracted by mini-css-extract-plugin
module.exports = {"navigation-item":"styles_navigation-item__5PkN0"};